import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { RoadmapTableFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_stacktrace/product-roadmap/_layout/')({
  validateSearch: zodValidator(RoadmapTableFilterSchema),
});
